<template>
  <svg class="breadcrumb-arrow" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 30 30" width="30px" height="30px">
    <path fill="currentColor" d="M11.7,26.6c-0.3,0-0.6-0.1-0.9-0.4c-0.5-0.5-0.5-1.3,0-1.8l9.2-9.2L10.8,6c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0l10.1,10.1c0.2,0.2,0.4,0.6,0.4,0.9s-0.1,0.7-0.4,0.9L12.6,26.2C12.4,26.4,12,26.6,11.7,26.6z"/>
  </svg>
</template>
